export default __webpack_public_path__ + "static/media/fleet-logo.0353a5f8.png";